import { boldMarkPlugin, boldMark } from "./boldMark.js";
import { createMarkHtmlDeserializer } from "../../../baseEditor/CustomMarkPlugin.js";
const withBold = (editor) => {
  editor.registerMark(boldMarkPlugin);
  editor.htmlDeserializer.registerPlugin(
    createMarkHtmlDeserializer(
      boldMark,
      (el) => el.nodeName === "STRONG" || el.nodeName === "B" && !el.id.startsWith("docs-internal-guid"),
      (el) => ["italic", "oblique"].includes(el.style.fontWeight)
    )
  );
  return editor;
};
export {
  withBold
};
//# sourceMappingURL=withBold.js.map
